import { getOptionsGlobal } from 'actions/global';
import BWAccordion from 'components/shared/BWAccordion';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormItem from 'components/shared/BWFormControl/FormItem';
import FormSelect from 'components/shared/BWFormControl/FormSelect';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { mapDataOptions4Select } from 'utils/helpers';
import { getList as getRecruitmentList } from 'services/recruitment.service';

const ApplicationInformation = ({ disabled, title }) => {
  const dispatch = useDispatch();
  const methods = useFormContext();
  const { businessData, positionData, departmentData } = useSelector((state) => state.global);
  const [recruitmentList, setRecruitmentList] = useState([]);

  // load options
  const getOptions1Time = useCallback(() => {
    dispatch(getOptionsGlobal('business'));
    dispatch(getOptionsGlobal('position'));
    dispatch(getOptionsGlobal('department'));
  }, [dispatch]);
  useEffect(getOptions1Time, [getOptions1Time]);

  // Load recruitment list
  useEffect(() => {
    getRecruitmentList({ is_active: 1, itemsPerPage: 999 })
      .then((response) => {
        setRecruitmentList(response?.items || []);
      })
      .catch((err) => {
        console.error('Error loading recruitment list:', err);
      });
  }, []);


  return (
    <BWAccordion title={title}>
      <div className='bw_row'>
        <div className='bw_col_12'>
          <FormItem label='Tin tuyển dụng' disabled={disabled} isRequired>
            <FormSelect
              field='recruitment_id'
              placeholder='-- Chọn tin tuyển dụng --'
              list={mapDataOptions4Select(recruitmentList, 'recruitment_id', 'recruitment_name')}
              validation={{
                required: 'Tin tuyển dụng là bắt buộc'
              }}
            />
          </FormItem>
        </div>
        <div className='bw_col_6'>
          <FormItem label='Tên tin tuyển dụng' disabled={true}>
            <FormInput
              field='recruitment_name'
              placeholder='Tên tin tuyển dụng'
              disabled
            />
          </FormItem>
        </div>
        <div className='bw_col_6'>
          <FormItem label='Bệnh viện, cơ sở' disabled={true}>
            <FormSelect
              field='business_id'
              list={mapDataOptions4Select(businessData)}
              disabled
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Phòng ban, chuyên khoa' disabled={true}>
            <FormSelect
              field='department_id'
              list={mapDataOptions4Select(departmentData)}
              disabled
            />
          </FormItem>
        </div>

        <div className='bw_col_6'>
          <FormItem label='Vị trí tuyển dụng' disabled={true}>
            <FormSelect
              field='position_id'
              list={mapDataOptions4Select(positionData)}
              disabled
            />
          </FormItem>
        </div>
      </div>
    </BWAccordion>
  );
};

export default ApplicationInformation;
